<template>
    <footer class="font-small pt-3 fixed-bottom" style="margin-top: 20px;">
        <div id="footer" class="footer_style ">
            <div class="container-fluid container_footer bt-space">
                <div>
                    <span class="footer_copyright">Copyright © 2022
                        <a href="https://simsol.in"  target="_SEJ" rel=”noreferrer”> SimSol Technologies and Services Private Limited
                        </a>
                        | All Rights Reserved.
                    </span>
                </div>
                <div class="footer_copyright" id="page_load">
                </div>
            </div>
        </div>
    </footer>
  </template>
  
  <script lang="ts">
  import { Options, Vue } from 'vue-class-component';
  
  @Options({})
  export default class Footer extends Vue {
    msg!: string
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
 
  </style>
  